import React from 'react';
import styled from 'styled-components/macro';
import { WithTranslation, withTranslation } from 'react-i18next';
import { DiscountItem } from '../../../../types/receipts';
import { Tr } from '../../../../components/Table/Fake';
import { colors } from '../../../../styles/constants';
import Discount from './discount';

interface DiscountsProps extends WithTranslation {
    discounts: DiscountItem[];
    currency?: string;
    lng: string;
}


const Discounts = (
    {
        discounts,
        currency,
        t,
    }: DiscountsProps
) => {
    return (
        <DiscountsTr as="tr">
            <td colSpan={4}>
                <DiscountsContainer>
                    <DiscountHeader>{t('customers.customer.receipt.fields.discounts')}</DiscountHeader>
                    {discounts.map((discount) => (
                        <Discount
                            discount={discount}
                            key={discount.discount_id}
                            currency={currency}
                        />
                    ))}
                </DiscountsContainer>
            </td>
        </DiscountsTr>
    );
};

const DiscountsContainer = styled.div`
    padding: 0 10px 20px 10px;
`;

const DiscountsTr = styled(Tr)`
    border-bottom: 1px solid ${colors.borderLight};
`;

const DiscountHeader = styled.h2`
    margin: 10px 0;
    padding: 0;
    font-size: 14px;
    color: #7d8a8c;
    text-transform: uppercase;
`;

export default withTranslation()(Discounts);
